import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import {createSummaryRpt} from '../Reports/SectionSummaryRpt';
import {RadioButtonGroup, RadioButton} from 'material-ui/RadioButton'
import Divider from 'material-ui/Divider'
import {createAnswerRpt} from '../Reports/AnswersRpt'
import { makeTitle } from '../reducer';
import UserResponseList from "./UserResponseList";
import { Provider } from 'react-redux';
import { store } from '../index';


class MultiExportsPopUp extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      responseViewingID: props.id,
      exportType: 'answers',
      createExport: false
    }
  }

  handleGenExport = handleDenExportRef => {
    this.setState({
      handleGenExportClick: handleDenExportRef
    });
  };


  render(){
    return(
      <div>
        <Divider />
        <div style={{display: 'flex', alignItems:'center'}}>
          <div style={{color:'black'}}>Choose Export:</div>
          <RadioButtonGroup name="exportType" defaultSelected="answers" onChange={this.onExportTypeChange.bind(this)}>
            <RadioButton value="answers" label="Answers" style={{ display: 'inline-block', width: '125px' }} />
            <RadioButton value="options" label="Options" style={{ display: 'inline-block', width: '125px' }} />
          </RadioButtonGroup>
        </div>

        <Provider store={store}>
          <UserResponseList limit={5} forReports={true} handleCreateExport={this.handleGenExport} section={this.props.section} calculateResults={this.props.calculateResults} {...this.props} />
        </Provider>
      </div>
    );
  }


  onExportTypeChange(e, value){
    this.setState({
      exportType: value
    });
  }

  genExport = (exportType) => {
    this.state.handleGenExportClick(exportType)
  }
}
export default MultiExportsPopUp;
